export default {"src":"/_next/static/image/public/images/ic_cross_blue.94a16ad5321078e916b51302ada67c75.svg","height":15,"width":15};